import { HttpParams } from "@angular/common/http";
import { Sort } from "@angular/material/sort";

/**
 *  Generate a sort string to be used by a sort endpoint.
 *  Must generate a string like: &sort={sortType},{direction}
 *
 *  If the sortType is a date like displayConfirmedScheduling,
 *  we should add a period sort beucause the column "date - period".
 *  E.g.: &sort=date,asc&sort=period,desc&sort=id,asc
 * @param sort
 * @returns the string to be used by a sort endpoint.
 * @deprecated 28/11/2023 - sprint 15 |
 * because the url params will be constructed using the HttpParams();
 * use generateSortValues() instead.
 */
export const generateSortString = (sort: Sort): string => {
  if (!sort) return "";
  if (!sort.active) return "";

  if (!sort.direction) return "";

  const direction = sort.direction;
  const changeDirection = {
    asc: "desc",
    desc: "asc"
  };
  const oppositeDirection = changeDirection[direction];

  const sortStringKey = {
    modelName: "vehicleLicensePlate",
    displayConfirmedScheduling: "date",
    carWorkshopName: "carWorkshopName",
    cityStateName: "vehicle.city.name"
  };

  let sortString = "&sort=";
  sortString += sortStringKey[sort.active] || sort.active;
  sortString += `,${direction}`;

  if (sort.active === "displayConfirmedScheduling")
    sortString += `&sort=period,${oppositeDirection}`;
  sortString += sort.active != "id" ? `&sort=id,${direction}` : "";
  return sortString;
};

export const generateSortValues = (sort: Sort): string[] =>
  generateSortString(sort)
    .split("&sort=")
    .filter((part) => part)
    .map((part) => part.replace("&sort=", ""));

export function populateParamsWithSortValues(
  sort: Sort,
  params: HttpParams
): HttpParams {
  generateSortValues(sort).forEach((value) => {
    params = params.append("sort", value);
  });

  return params;
}
